<section
    [style.height]="height + 'px'"
    [style.margin]="margin"
    [style.width]="width + 'px'"
    class="mat-spinner-container"
>
    <mat-progress-spinner
        [diameter]="diameter"
        [mode]="mode"
        [strokeWidth]="strokeWidth"
    ></mat-progress-spinner>
</section>
